export class ContractUtils {
    public static subTypes: Map<string, string> = new Map<string, string>([
        ['internet', 'Internet'],
        ['landline', 'Ligne fixe'],
        ['4ghome', 'Flybox'],
        ['homelive', 'Objets connectés'],
        ['airbox', 'Tablette / clé internet / airbox'],
        ['mobile', 'Mobile'],
        ['open', 'Pack internet + mobile'],
        ['parnasse', 'Contrat professionnel'],
    ]);
}
